export default __webpack_public_path__ + "static/media/mypicture-dark.71aea629.png";